import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import PersonRemoveOutlinedIcon from '@mui/icons-material/PersonRemoveOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import SendIcon from '@mui/icons-material/Send';
import ProfileDropdownStyles from "./ProfileDropdown.module.css";
import EmployeeBulkActionModal from "components/Content/Modal/EmployeeBulkActionModal";
import SendEmailDialog from "components/Content/Modal/SendEmailDialog";

function BulkActionsDropdown({ data, reloadEmployees }) {
  const [openModal, setOpen] = useState(false);
  const [bulkAction, setBulkAction] = useState();
  const [isSendEmailOpen, setIsSendEmailOpen] = useState(false);

  const handleTermination = () => {
    setBulkAction("Termination");
    setOpen(true);
  };
  const handleRehire = () => {
    setBulkAction("Rehire");
    setOpen(true);
  };
  const handleResetPassword = () => {
    setBulkAction("ResetPassword");
    setOpen(true);
  };
  const handleCommunication = () => {
    setIsSendEmailOpen(true);
  }

  return (
    <div className={ProfileDropdownStyles.bulkDropdownWrapper}>
      <Box className="d-flex content-justify-end align-items-center">
        <Button
          className="me-2"
          variant="outlined"
          onClick={handleTermination}
          startIcon={<PersonRemoveOutlinedIcon />}
        >
         Terminate EEs
        </Button>
        <Button
          className="me-2"
          variant="outlined"
          onClick={handleRehire}
          startIcon={<PersonAddAlt1OutlinedIcon />}
        >
         Rehire EEs
        </Button>
        <Button
          className="me-2"
          variant="outlined"
          onClick={handleCommunication}
          startIcon={<SendIcon />}
        >
         Send Communication
        </Button>
      </Box>

      <EmployeeBulkActionModal
        isOpen={openModal}
        closeModal={(openModal) => setOpen(openModal)}
        dataNames={data}
        bulkType={bulkAction}
        reloadEmployees={reloadEmployees}
      />
      <SendEmailDialog isOpen={isSendEmailOpen} handleClose={() => setIsSendEmailOpen(false)} names={data} />
    </div>
  );
}

export default BulkActionsDropdown;
